import { useTheme } from "./ThemeProvider";
import kartlyLogoLight from "../images/kartly-logo.png";
import kartlyLogoDark from "../images/kartly-logo-dark.png";

interface ThemeLogoProps {
  className?: string;
  alt?: string;
  onClick?: () => void;
  style?: React.CSSProperties;
}

export function ThemeLogo({
  className = "",
  alt = "Kartly Logo",
  onClick,
  style,
}: ThemeLogoProps) {
  const { theme } = useTheme();

  return (
    <img
      src={theme === "dark" ? kartlyLogoDark : kartlyLogoLight}
      alt={alt}
      className={className}
      onClick={onClick}
      style={{
        objectFit: "contain",
        transition: "all 0.3s ease",
        ...style,
      }}
    />
  );
}
